import { InjectionToken } from '@angular/core';

export const USE_CART = new InjectionToken<'active' | 'main' | 'string'>('USE_CART', {
  providedIn: 'root',
  factory: () => 'active',
});
